import React from "react";

const CheckboxIconInactive = ({ size = 16, color = "blue" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill={color}
    viewBox="0 0 24 24"
  >
    <path d="M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"></path>
  </svg>
);

// Reference: https://freeicons.io/documents-icons-2/icon-lock-icon-7535
const LockIcon = ({ size = 24, color = "red", strokeWidth = 2 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    stroke={color}
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeMiterlimit="10"
  >
    <path d="M9,13h17v16H6V13H9v-3c0-3.8,3.1-7,7-7h0c3.8,0,7,3.1,7,7v3"></path>
    <line x1="16" y1="22" x2="16" y2="24"></line>
    <circle cx="16" cy="20" r="2"></circle>
  </svg>
);

const SwitchOnIcon = ({ size = 24 }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" width={size} height={size}>
    <rect x="2" y="6" width="20" height="12" rx="6" ry="6" fill="#1568A6"/>
    <circle cx="16" cy="12" r="4" fill="white"/>
  </svg>
);

const SwitchOffIcon = ({ size = 24 }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" width={size} height={size}>
    <rect x="2" y="6" width="20" height="12" rx="6" ry="6" fill="#dee2e6"/>
    <circle cx="8" cy="12" r="4" fill="white"/>
  </svg>
);

export { CheckboxIconInactive, LockIcon, SwitchOnIcon, SwitchOffIcon };